import { render } from "./AddInfo.vue?vue&type=template&id=6e73675a&scoped=true&ts=true"
import script from "./AddInfo.vue?vue&type=script&lang=ts"
export * from "./AddInfo.vue?vue&type=script&lang=ts"

import "./AddInfo.vue?vue&type=style&index=0&id=6e73675a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e73675a"]])

export default __exports__